<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditContactDetailsDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditContactDetailsDialog from "@/views/settings/components/dialogs/EditContactDetailsDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditContactDetailsAction",
  components: { PrimaryButton, EditContactDetailsDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
